"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { MapPin, Globe } from "lucide-react";
const products = [{
  label: "Sales Recruiting",
  path: "/SalesRecruitingPage"
}, {
  label: "Insurance Agent Recruiting",
  path: "/InsuranceMedicareRecruitingPage"
}, {
  label: "Medicare Agent Recruiting",
  path: "/MedicareAgentRecruitingPage"
}, {
  label: "AI Auditing",
  path: "/ServicesPage"
}, {
  label: "Forensic Analysis",
  path: "/ServicesPage"
}];
function QuickLinksMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors block">
            Home
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors block">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="256552" id="footer" className="bg-background pt-16 pb-8 border-t border-primary/50 font-sans text-base">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          {}
          <div className="flex flex-col gap-4">
            <Link to="/HomePage" className="inline-block w-fit">
              <WvcLogo className="h-8 w-auto text-foreground grayscale brightness-200" />
            </Link>
            <p className="text-muted-foreground leading-relaxed mt-2 font-default">
              Optimus AI provides AI‑powered recruiting, talent acquisition, and business development services for insurance agencies, AI startups, SaaS companies, and growing enterprises.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-bold text-foreground font-default tracking-wider uppercase text-sm">Legal & Compliance</h3>
            <MenuProvider menu_id="16">
              <QuickLinksMenu />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-bold text-foreground font-default tracking-wider uppercase text-sm">Our Expertise</h3>
            <ul className="space-y-3">
              {products.map((product, i) => <li key={i} data-index={i}>
                  <Link to={product.path} className="text-muted-foreground hover:text-primary transition-colors block font-default">
                    {product.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-bold text-foreground font-default tracking-wider uppercase text-sm">Global Presence</h3>
            <ul className="space-y-4">
              <li data-index={0} className="flex items-start gap-3 text-muted-foreground">
                <MapPin className="w-5 h-5 shrink-0 text-primary mt-0.5" />
                <span className="font-default">Watertown, South Dakota</span>
              </li>
              <li data-index={1} className="flex items-start gap-3 text-muted-foreground">
                <Globe className="w-5 h-5 shrink-0 text-primary mt-0.5" />
                <Link to="/HomePage" className="hover:text-primary transition-colors break-all font-mono text-xs">
                  optimusoai.us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4 text-muted-foreground text-[11px] tracking-widest uppercase">
          <p>© {currentYear} OPTIMUS AI. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
        <p className="text-muted-foreground text-xs font-mono mt-4 text-center md:text-left">
          Optimus AI is an independent recruiting and business development firm. All recruiting services are provided with AI-enhanced sourcing technology to ensure high-quality talent acquisition.
        </p>
      </div>
    </section>;
}